<div class="flex flex-col p-4">
  <ng-container >
    <!-- First Section (hasMetConsensus is true) -->
    <div id="major-consensus_section" class="flex items-center justify-between px-4 pt-2 mt-8 border border-green-500 border-solid rounded-md bg-green-50"
    [ngClass]="{'border-warningOrange-500 bg-warningOrange-50' : !hasMetSimpleMajorityConsensus}">

      <span class="flex items-center">
        <span class="mb-2 mr-2">
          67% Rule (Simple Majority)
        </span>
        <div class="relative inline-block">
          <span id="help_icon" class="cursor-pointer material-symbols-rounded" (click)="openHelpModalForSimpleMajority()">help</span>
          <div id="help_modal" *ngIf="isShowHelpForSimpleMajority" class="absolute z-10 p-3 mt-2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg top-full left-1/2 w-96">
            <div class="flex items-center justify-between">
              <span class="text-sm font-semibold">67% Rule (Simple Majority)</span>
              <button class="text-gray-500 hover:text-gray-700" (click)="closeHelpModalForSimpleMajority()">
                <span class="material-symbols-rounded">close</span>
              </button>
            </div>
            <hr class="my-1 border-t-2 border-black" />
            <span class="mt-2 text-sm text-gray-700">
              The criteria of minimum 67% of those eligible to vote have voted affirmatively has been met.
            </span>
            <div class="absolute -top-4 pt-1 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-b-[15px] border-b-white"></div>
          </div>
        </div>
      </span>
      <p *ngIf="hasMetSimpleMajorityConsensus" class="flex items-center">
        Passed
        <span class="ml-2 text-green-500 cursor-default material-symbols-rounded">check_circle</span>
      </p>
      <p *ngIf="!hasMetSimpleMajorityConsensus" class="flex items-center">
        Simple Majority Not Met
        <span class="ml-2 cursor-default material-symbols-rounded text-warningOrange-500">warning</span>
      </p>
    </div>
  </ng-container>

  <!-- Second Section (hasMetConsensus is false) -->
  <ng-container>
    <div id="full-consensus_met_section" class="flex items-center justify-between px-4 pt-2 mt-8 border border-green-500 border-solid rounded-md bg-green-50" id="not_met_bar"
    [ngClass]="{'border-warningOrange-500 bg-warningOrange-50' : !hasMetForFullConsensus}"
    >
      <span class="flex items-center">
        <span class="mb-2 mr-2">
          80% Rule (Full Consensus With 80% Rule)
        </span>
        <div class="relative inline-block">
          <span id="help_icon" class="cursor-pointer material-symbols-rounded" (click)="openHelpModalForFullConsensus()">help</span>
          <div id="help_modal" *ngIf="isShowHelpForFullConsensus" class="absolute z-10 p-3 mt-2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg top-full left-1/2 w-96">
            <div class="flex items-center justify-between">
              <span class="text-sm font-semibold">80% Rule (Full Consensus With 80% Rule)</span>
              <button class="text-gray-500 hover:text-gray-700" (click)="closeHelpModalForFullConsensus()">
                <span class="material-symbols-rounded">close</span>
              </button>
            </div>
            <hr class="my-1 border-t-2 border-black" />
            <span class="mt-2 text-sm text-gray-700">
              The criteria of minimum 80% of the votes received (excluding no response) are affirmative has been met.
            </span>
            <div class="absolute -top-4 pt-1 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-b-[15px] border-b-white"></div>
          </div>
        </div>
      </span>
      <p *ngIf="hasMetForFullConsensus" class="flex items-center">
        Passed
        <span class="ml-2 text-green-500 cursor-default material-symbols-rounded">check_circle</span>
      </p>
      <p *ngIf="!hasMetForFullConsensus" class="flex items-center">
        80% Rule Not Met
        <span class="ml-2 cursor-default material-symbols-rounded text-warningOrange-500">warning</span>
      </p>
    </div>
  </ng-container>
</div>
